import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient unico da SPA web.
 *
 * Defaults conservadores: staleTime 30s para evitar refetch agressivo
 * em navegacao curta entre telas; retry 1 para nao mascarar erros reais
 * com loops de tentativa.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
